import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMonthlyLeaderboard } from '../services/api';

/**
 * Simplified AdminAnalytics page
 * ─────────────────────────────
 * ‑ Fetches **only** the monthly leaderboard
 * ‑ Removes transactions, rebates & notifications logic/UI
 */
function AdminAnalytics() {
  const navigate = useNavigate();

  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);
  const [leaderboard, setLb]    = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin/login');
      return;
    }
    fetchLeaderboard(token);
  }, [navigate]);

  async function fetchLeaderboard(token) {
    try {
      setLoading(true);
      setError(null);
      const data = await getMonthlyLeaderboard(token);
      setLb(data);
    } catch (err) {
      console.error('[AdminAnalytics] getMonthlyLeaderboard failed', err);
      setError('Failed to load leaderboard — please try again.');
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <div>Loading…</div>;
  if (error)   return <div className="error">{error}</div>;

  return (
    <div className="admin-analytics">
      <h1>Admin Analytics Dashboard</h1>

      {/* Leaderboard */}
      <section>
        <h2>Monthly Leaderboard</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Rank</th>
                <th>User</th>
                <th>Score</th>
              </tr>
            </thead>
            <tbody>
              {leaderboard.map((entry, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{entry.user}</td>
                  <td>{entry.score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

export default AdminAnalytics;
